import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { OrdersStatsService, OrdersSummaryRow } from './ordersStats.service';

@Component({
  selector: 'ordersStats',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.scss']
})
export class ordersStats implements OnInit {
  /** Auto-wire paginator & sort even if they appear after dataSource is created */
  private _paginator!: MatPaginator;
  private _sort!: MatSort;

  @ViewChild(MatPaginator) set matPaginator(p: MatPaginator) {
    this._paginator = p;
    if (this.dataSource) this.dataSource.paginator = p;
  }
  @ViewChild(MatSort) set matSortRef(s: MatSort) {
    this._sort = s;
    if (this.dataSource) this.dataSource.sort = s;
  }
  @ViewChild(MatTable) table!: MatTable<OrdersSummaryRow>;

  dataSource = new MatTableDataSource<OrdersSummaryRow>([]);
  displayedColumns: string[] = ['project_id', 'project_name', 'total_orders', 'total_value', 'currency'];
  isLoaded = false;

  // Date range state (bound to the range picker)
  startDate: Date | null = null;
  endDate: Date | null = null;

  // Central list of project IDs (keep here or move into the service if you prefer)
  private readonly projectIds: string[] = [
    '9748','10238','10249','10281','10317','10324','10318','10291','10218','6510',
    '9778','9596','10133','10126','10201','10221','10222','10165','10238','10239',
    '10247','10258','10260','10264','10273','10278','10368','10276','10283','10286',
    '10288','10289','10290','10292','10322','10319','10323','10327','10331','10333',
    '10334','10346','10336','10347','10351','10353','10352','10350','10354','10361',
    '10358','10365','10360','10362','10374','10363','10366','10369','10372','10376',
    '10379','10380','10381','10384','10382','10386','10296','10390','10388','10389',
    '10391','10393',
  ];

  constructor(private ordersService: OrdersStatsService) {}

  ngOnInit(): void {
    this.loadSummaries(); // initial load with no date filter
  }

  /** Load / reload summaries using the current date range */
  loadSummaries(): void {
    this.isLoaded = false;
    this.ordersService.getProjectSummaries(this.projectIds, this.startDate, this.endDate).subscribe({
      next: (rows) => {
        this.dataSource = new MatTableDataSource<OrdersSummaryRow>(rows);
        this.dataSource.paginator = this._paginator;
        this.dataSource.sort = this._sort;
        this.isLoaded = true;
        this.table?.renderRows();
      },
      error: (err) => {
        console.error('Failed to load project summaries', err);
        this.isLoaded = true;
      }
    });
  }

  /** Called when the date range is picked/changed */
  applyDateRange(): void {
    // normalize to midnight for inclusive comparisons
    if (this.startDate) this.startDate = new Date(this.startDate.getFullYear(), this.startDate.getMonth(), this.startDate.getDate());
    if (this.endDate)   this.endDate   = new Date(this.endDate.getFullYear(),   this.endDate.getMonth(),   this.endDate.getDate());
    this.loadSummaries();
  }

  /** Clear the date range and reload all data */
  clearDateRange(): void {
    this.startDate = null;
    this.endDate = null;
    this.loadSummaries();
  }
}
